module.exports = __webpack_public_path__ + "static/media/ppl_illustration.6c4ae326.svg";